document.addEventListener('DOMContentLoaded', () => {
  const isTouchDevice = window.matchMedia('(hover: none), (pointer: coarse)').matches;

  function notifyCartAdd(cartData) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cartData,
        sourceId: 'album-hover',
        data: {
          source: 'product-form-component',
          itemCount: 1,
        },
      },
    }));
  }

  function initBackdrop(card) {
    const image = card.querySelector('.urs-album-card__image');
    const backdrop = card.querySelector('.urs-album-card__hero-backdrop');
    if (image && backdrop && !backdrop.style.backgroundImage) {
      backdrop.style.backgroundImage = `url("${image.currentSrc || image.src}")`;
    }
  }

  function closeCard(card) {
    card.classList.remove('is-active');
    const audio = card.querySelector('[data-audio-player]');
    const audioWrap = card.querySelector('.urs-audio-wrap');
    const toggle = card.querySelector('[data-audio-toggle]');
    if (audio) { audio.pause(); audio.currentTime = 0; }
    if (audioWrap) audioWrap.hidden = true;
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  // --- Event Delegation: works for all cards, including infinite-scroll ---

  document.addEventListener('click', (event) => {
    const addBtn = event.target.closest('[data-add-to-cart]');
    if (addBtn) {
      event.preventDefault();
      event.stopPropagation();
      handleAddToCart(addBtn);
      return;
    }

    const audioToggle = event.target.closest('[data-audio-toggle]');
    if (audioToggle) {
      event.preventDefault();
      event.stopPropagation();
      handleAudioToggle(audioToggle);
      return;
    }

    const card = event.target.closest('[data-album-card]');
    if (card) {
      if (isTouchDevice) {
        const clickedInteractive = event.target.closest('a, button, audio');
        if (!clickedInteractive) {
          handleTouchTap(card);
        }
      }
      initBackdrop(card);
      return;
    }

    // Click outside any card — close all active
    document.querySelectorAll('[data-album-card].is-active').forEach(closeCard);
  });

  // Init backdrops for cards already in DOM
  document.querySelectorAll('[data-album-card]').forEach(initBackdrop);

  // --- Handlers ---

  async function handleAddToCart(btn) {
    const variantId = btn.dataset.variantId;
    const defaultText = btn.dataset.defaultText || 'Add to cart';
    const addedText = btn.dataset.addedText || 'Added \u2713';
    const soldOutText = btn.dataset.soldOutText || 'Sold out';

    if (!variantId) {
      btn.textContent = soldOutText;
      btn.disabled = true;
      btn.classList.add('is-disabled');
      return;
    }

    if (btn.dataset.loading === 'true') return;

    btn.dataset.loading = 'true';
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.textContent = 'Adding...';

    try {
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });

      if (!res.ok) throw new Error(`Add to cart failed: ${res.status}`);

      const data = await res.json();
      notifyCartAdd(data);

      btn.textContent = addedText;
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');

      setTimeout(() => {
        btn.textContent = defaultText;
        btn.disabled = false;
        btn.dataset.loading = 'false';
        btn.classList.remove('is-added', 'is-loading');
      }, 1800);
    } catch (error) {
      console.error(error);
      btn.textContent = 'Try again';
      btn.disabled = false;
      btn.dataset.loading = 'false';
      btn.classList.remove('is-loading');

      setTimeout(() => { btn.textContent = defaultText; }, 1800);
    }
  }

  function handleAudioToggle(toggle) {
    const card = toggle.closest('[data-album-card]');
    if (!card) return;

    const audioWrap = card.querySelector('.urs-audio-wrap');
    const audio = card.querySelector('[data-audio-player]');
    if (!audioWrap || !audio) return;

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    const nextState = !isExpanded;

    audioWrap.hidden = !nextState;
    toggle.setAttribute('aria-expanded', String(nextState));

    if (nextState) {
      audio.play().catch(() => {});
    } else {
      audio.pause();
      audio.currentTime = 0;
    }
  }

  function handleTouchTap(card) {
    const wasActive = card.classList.contains('is-active');

    document.querySelectorAll('[data-album-card].is-active').forEach((active) => {
      if (active !== card) closeCard(active);
    });

    card.classList.toggle('is-active', !wasActive);
  }
});
